<!--

  Implementation

  -in template:


  -import:

-->


<template>
  <slotted-dialog :title="customer.Name + ' ' + $t('servicesystem.common_objects.job.jobs').toLowerCase()"
                  :externaltrigger="dialogtrigger"
                  :externalCloseTrigger="closetrigger">

    <template v-slot:content>

      <v-card class="ma-4"
              color="transparent"
              flat>
        <v-expansion-panels>
          <UpcomingJobs :id="customer.Id"
                        :customer="true" />
          <ActiveJobs :id="customer.Id"
                      :customer="true" />
          <ClosedJobs :id="customer.Id"
                      :customer="true" />
        </v-expansion-panels>
      </v-card>

    </template>

  </slotted-dialog>
</template>


<script>
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import UpcomingJobs from "@/components/Preview/UpcomingJobsPreview.vue";
import ActiveJobs from "@/components/Preview/ActiveJobsPreview.vue";
import ClosedJobs from "@/components/Preview/ClosedJobsPreview.vue";

export default {
  name: "CustomerJobsDialog",
  props: ["externaltrigger", "customer"],
  components: { SlottedDialog, UpcomingJobs, ActiveJobs, ClosedJobs },

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
    };
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {
    externaltrigger: function () {
      this.dialogtrigger++;
    },

    /*
    storeTrigger: function () {
      this.dialogtrigger++;
    },
    */
  },
};
</script>